import React from "react";
import { ShieldCheck, Sparkles, HeartPulse } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Protect",
    body: "Remove mold, mildew, algae & dirt that can damage your siding, roof, and concrete over time.",
    color: "from-sky-100 to-white",
  },
  {
    icon: Sparkles,
    title: "Enhance",
    body: "Boost curb appeal and keep your home or business looking its absolute best, year-round.",
    color: "from-amber-100 to-white",
  },
  {
    icon: HeartPulse,
    title: "Healthier",
    body: "Eliminate harmful buildup to create a cleaner, safer environment for your family and customers.",
    color: "from-emerald-100 to-white",
  },
];

export default function WhyUs() {
  return (
    <section id="why" className="py-20 md:py-28 bg-[var(--fc-surface)]" data-testid="whyus-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="font-script text-3xl text-[var(--fc-orange)]">Bring new life</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold text-[var(--fc-blue-dark)] mt-1">
            Cleaner. Safer. Healthier.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {ITEMS.map((it) => (
            <div
              key={it.title}
              className={`rounded-3xl p-8 bg-gradient-to-b ${it.color} border border-blue-100 shadow-lg shadow-blue-900/5 hover:-translate-y-1 transition-transform`}
              data-testid={`why-card-${it.title.toLowerCase()}`}
            >
              <div className="w-16 h-16 rounded-2xl btn-blue flex items-center justify-center">
                <it.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-[var(--fc-blue-dark)] mt-5">
                {it.title}
              </h3>
              <p className="mt-3 text-slate-700 leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-3xl bg-gradient-to-r from-[var(--fc-blue-deep)] to-[var(--fc-blue-dark)] text-white p-8 md:p-12 grid md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-2">
            <div className="font-script text-3xl text-[var(--fc-yellow)]">Our promise</div>
            <h3 className="font-heading text-3xl md:text-4xl font-bold mt-1">
              We clean with purpose. We serve with integrity.
            </h3>
            <p className="mt-3 text-white/85 max-w-2xl">
              Faith-based, honest, reliable — dedicated to excellence on every job, every time.
            </p>
          </div>
          <a
            href="#estimate"
            className="justify-self-start md:justify-self-end inline-flex items-center btn-orange font-heading font-extrabold uppercase tracking-wider px-7 h-14 rounded-full"
            data-testid="whyus-cta-estimate"
          >
            Free Estimate
          </a>
        </div>
      </div>
    </section>
  );
}
